<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8749 8.42109H14.7116L19.3546 2.55469C19.4507 2.43047 19.3639 2.25 19.2069 2.25H10.2186C10.153 2.25 10.0897 2.28516 10.0569 2.34375L3.98425 12.832C3.9116 12.9563 4.00066 13.1133 4.14597 13.1133H8.23347L6.13816 21.4945C6.09363 21.6773 6.31394 21.8062 6.44988 21.675L20.0038 8.74219C20.1257 8.62734 20.0436 8.42109 19.8749 8.42109ZM8.86394 17.168L10.2772 11.5195H6.58816L11.0319 3.84609H16.296L11.4139 10.0172H16.3593L8.86394 17.168Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Thunderbolt' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
